import React from "react";
import PropTypes from "prop-types";
import { COPY_STRINGS } from "Constants/translatedCopy";
import predictionIcon from "./prediction-icon.jpg";
import { Container } from "../shared";
import PredictionMultipleChoice from "./PredictionMultipleChoice";
import { getRandomArrayElement } from "../../../app/utils";
import "./PredictionQuestion.scss";

export default class PredictionQuestion extends React.Component {
  isMounted = true;

  constructor(props) {
    super(props);
    this.state = {
      isLastQuestion: true, //Only one question
      isFirstQuestion: true, //because we initialize id to 0
      isCorrect: false,
      id: 0, //first one
      buttonsDisabled: true, //TODO do not default to enabled
      results: [],
      isClosed: false,
    };

    this.updateResults = this.updateResults.bind(this);
    this.speakEncouragement = this.speakEncouragement.bind(this);
    this.close = this.close.bind(this);
    this.expire = this.expire.bind(this);
    this.enableButtons = this.enableButtons.bind(this);
    this.disableButtons = this.disableButtons.bind(this);
  }

  componentDidMount() {
    this.isMounted = true;
    const { metadata } = this.props;

    if (
      !(metadata && metadata.text && metadata.distractors && metadata.correct)
    ) {
      this.close();
      return;
    }
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  enableButtons(callback = null) {
    this.setState({ buttonsDisabled: false }, () => {
      if (callback) {
        callback();
      }
    });
  }

  disableButtons(callback = null) {
    this.setState({ buttonsDisabled: true }, () => {
      if (callback) {
        callback();
      }
    });
  }

  speakEncouragement({ text, callback }) {
    this.props.speech.speak({
      textToSpeak: text,
      onEnd: callback,
    });
  }

  updateResults(
    tries,
    selectionHistory,
    response,
    allResponses,
    isCorrect = false
  ) {
    if (!this.isMounted) return;
    const { metadata } = this.props;
    let newResults = this.state.results;
    newResults[this.state.id] = {
      tries,
      selectionHistory,
      response,
    };

    const correctAnswer = metadata.correct;

    this.setState((prevState) => ({
      isCorrect,
      results: newResults,
      buttonsDisabled: allResponses.length < correctAnswer.length,
    }));

    if (isCorrect) {
      const feedback =
        COPY_STRINGS.intervention_strings.prediction_question.correct_response;

      this.setState(
        { buttonsDisabled: true },
        this.props.speech.speak({ textToSpeak: feedback, onEnd: this.close })
      );
    } else {
      this.speakEncouragement({
        text: COPY_STRINGS.intervention_strings.prediction_question.struggle,
      });
    }
  }

  close() {
    if (!this.isMounted) return;

    this.setState(
      { isClosed: true },
      this.props.handleMessage({
        continueWithoutSpeaking: true,
        endOfPhrase: this.props.endOfPhrase,
      })
    );
  }

  expire() {
    if (!this.isMounted) return;
    const { metadata } = this.props;
    const correctAnswer = metadata && metadata.correct ? metadata.correct : "";

    this.props.speech.speak({
      textToSpeak:
        COPY_STRINGS.intervention_strings.prediction_question.expire_right_answer(
          correctAnswer[0]
        ),
      onEnd: this.close,
    });
  }

  render() {
    const { metadata } = this.props;
    const distractors =
      metadata && metadata.distractors ? metadata.distractors : [];
    const correctAnswer = metadata && metadata.correct ? metadata.correct : "";
    const questionText = metadata && metadata.text ? metadata.text : "";
    const introText =
      COPY_STRINGS.intervention_strings.prediction_question.intro;

    return (
      <Container icon={predictionIcon}>
        <div className="predictionSelection">
          {metadata && (
            <PredictionMultipleChoice
              options={distractors}
              questionTitle={questionText}
              correctAnswer={correctAnswer}
              speech={this.props.speech}
              flat={true}
              introText={introText}
              readQuestion={true}
              updateResults={this.updateResults}
              buttonsDisabled={this.state.buttonsDisabled}
              enableButtons={this.enableButtons}
              disableButtons={this.disableButtons}
              expire={this.expire}
            />
          )}
        </div>
      </Container>
    );
  }
}

PredictionQuestion.propTypes = {
  metadata: PropTypes.object,
  endOfPhrase: PropTypes.bool,
  speech: PropTypes.object,
  handleMessage: PropTypes.func,
};
